module.exports = __webpack_public_path__ + "de77a722/img/arrow-left-icon.785c715c.svg";